/**
 * Buy Together Functions
 */

export function parcel(price, parcel_number) {
    const result = price / parcel_number;

    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
    }).format(result);
}

export function productsBuyTogether(elemento, desmarcar, is_position_side = false) {
    const product_id = $(elemento).data('buy-together-product-id') || $(elemento).closest('.buy-together').data('product-id');
    const $item = $('.buy-together-' + product_id);
    const $checkbox = $item.find('[data-buy-together-checkbox]');

    if (desmarcar === false) {
        $checkbox.prop('checked', false);

        $('#check-product-' + product_id)
            .removeClass('mdi-check-box add-item-success addBuyTogetherProduct')
            .addClass('mdi-check-box-outline-blank')
            .parent()
            .removeClass('text-success')
            .parent()
            .css({ 'border-color': '#DDD' });
    } else if (desmarcar === true) {
        $checkbox.prop('checked', true);

        $('#check-product-' + product_id)
            .removeClass('mdi-check-box-outline-blank')
            .addClass('mdi-check-box add-item-success addBuyTogetherProduct')
            .parent()
            .addClass('text-success')
            .parent()
            .css({ 'border-color': '#28a745' });
    }

    if (!is_position_side && ($('.buy-together-btn-content .price').length || $('.buy-together-btn-content .parcel').length)) {
        calculateBtTotal();
    }
}

export function btProductOption(element) {
    let buy_together_content = $(element).parents('.buy-together-info');
    let main_price = buy_together_content.find('.product-main-price');
    var calc_price = Number($(main_price).data('price_without_format'));

    let price_discount = buy_together_content.find('.product-price-discount .product-discount');
    var calc_price_discount = $(price_discount).length
        ? Number($(price_discount).data('price_discount_without_format').toString().replaceAll(",", ""))
        : 0;

    buy_together_content.find('select').each(function() {
        var option_price = $(this).find(':selected').data('option_price')
            ? $(this).find('option:selected').data('option_price')
            : 0;
        var option_price_prefix = $(this).find(':selected').data('option_price_prefix')
            ? $(this).find('option:selected').data('option_price_prefix')
            : '+';

        if (option_price_prefix === '+') {
            calc_price = calc_price + Number(option_price);
            calc_price_discount = calc_price_discount + Number(option_price);
        } else if (option_price_prefix === '-') {
            calc_price = calc_price - Number(option_price);
            calc_price_discount = calc_price_discount - Number(option_price);
        }
    });

    if (calc_price > 0) {
        let calc_price_formatted = new Intl.NumberFormat('pt-br', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2
        }).format(calc_price);
        $(main_price).text(calc_price_formatted);
    } else {
        $(main_price).text('R$ 0,00');
    }

    if (calc_price_discount > 0 && $(price_discount).length) {
        let calc_price_discount_formatted = new Intl.NumberFormat('pt-br', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2
        }).format(calc_price_discount);
        $(price_discount).text(calc_price_discount_formatted);
    } else if ($(price_discount).length) {
        $(price_discount).text('R$ 0,00');
    }
}

export function calculateBtTotal() {
    let bt_products = {};

    $('.buy-together-items-content .buy-together').each(function(index, buytogether) {
        if ($(buytogether).find('[data-buy-together-checkbox]').prop('checked') || $(buytogether).find('.buy-together-check.text-success').length) {
            let bt_options = {};

            $(buytogether).find('.buy-together-option-list select option:selected').each(function(index_opt, bt_option_selected) {
                let bt_option_price = $(bt_option_selected).data('option_price');
                let bt_option_price_prefix = $(bt_option_selected).data('option_price_prefix');

                bt_options[index_opt] = {
                    'opt_price': bt_option_price ? bt_option_price : 0,
                    'option_price_prefix': bt_option_price_prefix,
                }
            });

            let bt_product_price = 0;
            if ($(buytogether).find('.product-main-price').length) {
                bt_product_price = Number($(buytogether).find('.product-main-price').data('price_without_format'))
            } else if ($(buytogether).find('.product-price-new').length) {
                bt_product_price = Number($(buytogether).find('.product-price-new').data('price_new_without_format'))
            }

            bt_products[index] = {
                'price': bt_product_price,
                'options_price': bt_options
            }
        }
    });

    let data = {
        product_price: $('.buy-together-btn-content .price').data('price_without_format'),
        product_parcel_qtd: $('.buy-together-btn-content .parcel').data('parcels')
            ? $('.buy-together-btn-content .parcel').data('parcels')
            : 1,
        product_parcel_interest: $('.buy-together-btn-content .parcel').data('interest')
            ? $('.buy-together-btn-content .parcel').data('interest')
            : 0,
        bt_products: bt_products
    };

    $.ajax({
        url: `index.php?route=product/buy_together/calculateBtTotal&token=${$('input[name="token"]').val()}`,
        type: 'post',
        data: data,
        dataType: 'json',
        success: function(json) {
            $('.buy-together-btn-content .price').html(`<b>${json.total_price_formatted}</b>`);
            $('.buy-together-btn-content .parcel .parcel_price').html(`${json.total_parcel_formatted}`);
        },
        error: function(xhr) {
            console.error('Erro ao calcular total do compre junto:', xhr.responseText);
        }
    });
}

export function initBuyTogetherNavigation(buyTogetherCount) {
    if (buyTogetherCount >= 2) {
        $('.buy-together-nav-btn .mdi').off('click.buyTogetherNav').on('click.buyTogetherNav', function() {
            if (!$(this).parent().hasClass('nav-btn-disabled')) {
                if ($(this).parent().hasClass('buy-together-nav-up')) {
                    var scroll_position = $('.buy-together-items').scrollTop() - $('.buy-together-items').height() - 7;
                    $('.buy-together-items').scrollTop(scroll_position);
                } else {
                    var scroll_position = $('.buy-together-items').scrollTop() + $('.buy-together-items').height() + 7;
                    $('.buy-together-items').scrollTop(scroll_position);
                }

                if (!$('.buy-together-items').scrollTop()) {
                    $('.buy-together-nav-up').addClass('nav-btn-disabled');
                } else {
                    $('.buy-together-nav-up').removeClass('nav-btn-disabled');
                }

                if (($('.buy-together-items').scrollTop() + $('.buy-together-items').height()) == $('.buy-together-items-content').height()) {
                    $('.buy-together-nav-down').addClass('nav-btn-disabled');
                } else {
                    $('.buy-together-nav-down').removeClass('nav-btn-disabled');
                }
            }
        });
    }
}

export function initBuyTogetherEvents(is_position_side = false) {
    $('[data-buy-together-checkbox]').off('change.buyTogether').on('change.buyTogether', function() {
        productsBuyTogether(this, this.checked, is_position_side);
    });

    $('.buy-together-check').off('click.buyTogether').on('click.buyTogether', function() {
        if ($(this).siblings('[data-buy-together-checkbox]').length) {
            return;
        }

        if ($(this).hasClass('text-success')) {
            productsBuyTogether($(this).find('.productsBuyTogether'), false, is_position_side);
        } else {
            productsBuyTogether($(this).find('.productsBuyTogether'), true, is_position_side);
        }
    });

    $('.option-type-select').off('change.buyTogether').on('change.buyTogether', function() {
        var elemento = $(this).attr("id");
        var product_id = $("#" + elemento + " option:selected").data('product-id');

        if ($(this).val() === 'size_no_available') {
            handleOutOfStock(this, product_id, is_position_side);
        } else {
            handleInStock(this, product_id, is_position_side);
        }
    });

    $(document).off('click.buyTogetherAdd', '[data-buy-together-add]').on('click.buyTogetherAdd', '[data-buy-together-add]', async function(event) {
        event.preventDefault();
        await addBuyTogetherToCart($(this).closest('[data-buy-together-module="lime"]'), $(this));
    });
}

function handleOutOfStock(selectElement, product_id, is_position_side) {
    $(selectElement).val('0');
    $('.no_stock_text').remove();
    productsBuyTogether($('i[data-buy-together-product-id="' + product_id + '"]'), false, is_position_side);

    const outOfStockText = typeof text_out_of_stock_4 !== 'undefined'
        ? text_out_of_stock_4
        : 'Produto fora de estoque';

    $(`<span class="no_stock_text text">${outOfStockText}</span>`).insertAfter('.product_details #button-cart');
    $('.product_details #button-cart').fadeOut();

    var selected_option = $(selectElement).find('option:selected');
    var data_product_option_id = selected_option.data('product-option-id') || $(selectElement).attr('data-product-option-id');
    var data_product_option_value_id = selected_option.data('product-option-value-id') || $(selectElement).attr('data-product-option-value-id');
    var data_product_option_name = selected_option.data('product-option-name') || $(selectElement).attr('data-product-option-name');

    let html = '<div id="modal-notify" class="modal">';
    html += '  <div class="modal-dialog">';
    html += '    <div class="modal-content">';
    html += '      <div class="modal-body-center" id="notify-content">';
    html += '      </div>';
    html += '    </div>';
    html += '  </div>';
    html += '</div>';

    $('#modal-notify').remove();
    $('body').append(html);

    $('#notify-content').load('index.php?route=product/notify&product_id=' + product_id +
        '&data_product_option_name=' + data_product_option_name +
        '&data_product_option_id=' + data_product_option_id +
        '&data_product_option_value_id=' + data_product_option_value_id);

    $('#modal-notify').modal('show');
}

function handleInStock(selectElement, product_id, is_position_side) {
    $('.no_stock_text').remove();
    $('.product_details #button-cart').fadeIn();

    if ($(selectElement).val() === '0') {
        productsBuyTogether($('i[data-buy-together-product-id="' + product_id + '"]'), false, is_position_side);
    } else {
        productsBuyTogether($('i[data-buy-together-product-id="' + product_id + '"]'), true, is_position_side);
    }
}

function getSelectedBuyTogetherItems($root) {
    return $root.find('.buy-together').filter(function() {
        return $(this).find('[data-buy-together-checkbox]').prop('checked') ||
            $(this).find('.addBuyTogetherProduct').length ||
            $(this).find('.buy-together-check.text-success').length;
    });
}

function clearBuyTogetherErrors($root) {
    $root.find('.buy-together-alert').remove();
    $root.find('.has-error').removeClass('has-error');
}

function showBuyTogetherError($root, message) {
    const html = '<div class="buy-together-alert alert alert-danger text-danger d-block icon-left" role="alert"><span class="mdi mdi-error"></span> ' + message + '</div>';
    const $target = $root.find('.buy-together-btn-content').first();

    $root.find('.buy-together-alert').remove();

    if ($target.length) {
        $target.before(html);
    } else {
        $root.prepend(html);
    }
}

function validateBuyTogetherOptions($root, $items) {
    let has_error = false;

    $items.each(function() {
        const $item = $(this);

        $item.find('select.buy-together-opt').each(function() {
            const value = $(this).val();

            if (!value || value === '0' || value === 'size_no_available') {
                has_error = true;
                $(this).closest('.form-group').addClass('has-error');
            }
        });

        $item.find('input.buy-together-opt:not([type="hidden"]), textarea.buy-together-opt').each(function() {
            const required = $(this).data('option-required') == 1 || $(this).data('option-required') === '1' || $(this).closest('.required').length;

            if (required && !$(this).val()) {
                has_error = true;
                $(this).closest('.form-group, .options-list').addClass('has-error');
            }
        });

        $item.find('button[data-upload-option-id]').each(function() {
            const option_id = $(this).data('upload-option-id');
            const required = $(this).data('option-required') == 1 || $(this).data('option-required') === '1';
            const value = $item.find('input[data-upload-option-id="' + option_id + '"]').val();

            if (required && !value) {
                has_error = true;
                $(this).closest('.form-group, .options-list').addClass('has-error');
            }
        });
    });

    if (has_error) {
        showBuyTogetherError($root, $root.data('buy-together-option-error') || 'Selecione as opcoes dos produtos.');
    }

    return !has_error;
}

function getMainProductPayload() {
    const selector = [
        "#product input[type='text']:not(.buy-together-opt)",
        "#product input[type='time']:not(.buy-together-opt)",
        "#product input[type='datetime-local']:not(.buy-together-opt)",
        "#product input[type='hidden']:not(.buy-together-opt)",
        "#product #input-quantity",
        "#product input[type='radio']:checked:not(.buy-together-opt)",
        "#product input[type='checkbox']:checked:not(.buy-together-checkbox):not(.buy-together-opt)",
        "#product select:not(.buy-together-opt)",
        "#product textarea:not(.buy-together-opt)",
        "#__csrf"
    ].join(',');
    const payload = $(selector).serializeArray();

    const setPayloadValue = function(name, value) {
        let found = false;

        $.each(payload, function(index, item) {
            if (item.name === name) {
                found = true;
                item.value = value;
            }
        });

        if (!found) {
            payload.push({
                name: name,
                value: value
            });
        }
    };

    const quantity = $('#product input[name="quantity"]').not('.buy-together-opt').last().val();

    if (quantity) {
        setPayloadValue('quantity', quantity);
    }

    $(
        '#product .product_options_list .sizes.selected, ' +
        '#product .product-options-list .sizes.selected, ' +
        '.product-floating .product_options_list .sizes.selected, ' +
        '.product-floating .product-options-list .sizes.selected'
    ).each(function() {
        const $option = $(this);

        if ($option.closest('[data-buy-together-module="lime"]').length) {
            return;
        }

        const product_option_id = $option.data('product-option-id') || $option.attr('data-product-option-id');
        const product_option_value_id = $option.data('product-option-value-id') || $option.attr('data-product-option-value-id');
        const option_name = 'option[' + product_option_id + ']';

        if (!product_option_id || !product_option_value_id) {
            return;
        }

        setPayloadValue(option_name, product_option_value_id);
    });

    $('.product-floating select[name^="option"]:not(.buy-together-opt)').each(function() {
        if ($(this).val()) {
            setPayloadValue($(this).attr('name'), $(this).val());
        }
    });

    return $.param(payload);
}

function getBuyTogetherOptions($item) {
    const option = {};

    $item.find('select.buy-together-opt').each(function() {
        option[$(this).data('product-option-id')] = $(this).val();
    });

    $item.find('input.buy-together-opt, textarea.buy-together-opt').each(function() {
        const upload_option_id = $(this).data('upload-option-id');
        const product_option_id = $(this).data('product-option-id');

        if (upload_option_id) {
            option[upload_option_id] = $(this).val();
        } else if (product_option_id) {
            option[product_option_id] = $(this).val();
        }
    });

    return option;
}

function postCart(url, data) {
    return new Promise(function(resolve, reject) {
        $.ajax({
            url: url,
            type: 'post',
            data: data,
            dataType: 'json',
            success: resolve,
            error: reject
        });
    });
}

function getPackageParam() {
    const has_package = $(".sizes").hasClass('packageTrigger selected') ||
        $('#product .option-type-select:not(.buy-together-opt)').find('.packageTrigger').length > 0 ||
        $('#product .option_type_select:not(.buy-together-opt) > option').hasClass('packageTrigger') ||
        $('#input-quantity').hasClass('packageTrigger');

    return has_package ? 'packageTrigger' : '';
}

function addMainProductToCart($root) {
    const redirect = $root.data('buy-together-redirect') || '';
    const url = 'index.php?route=checkout/cart/add&package=' + getPackageParam() + '&v=' + new Date().getTime() + '&redirect=' + redirect;

    return postCart(url, getMainProductPayload());
}

function addBuyTogetherItemToCart($item) {
    const data = {
        product_id: $item.data('product-id'),
        quantity: 1,
        option: getBuyTogetherOptions($item),
        __csrf: $('#__csrf').val()
    };

    if ($('#images_customize').length) {
        data.customize_images = $('#images_customize').val();
    }

    return postCart('index.php?route=checkout/cart/add', data);
}

function renderMainProductErrors(json) {
    $('.text-danger').remove();
    $('.form-group').removeClass('has-error');
    $('#product .product-option-warning').remove();

    if (!json.error) {
        return;
    }

    if (json.error.option) {
        for (let i in json.error.option) {
            const element = $('#input-option' + i.replace('_', '-'));
            const html = '<div class="alert alert-danger text-danger d-block icon-left" role="alert"><span class="mdi mdi-error"></span> ' + json.error.option[i] + '</div>';

            if (element.parent().hasClass('input-group')) {
                element.parent().after(html);
            } else {
                element.after(html);
            }
        }

        $('.text-danger').parent().addClass('has-error');
        $('<div class="product-option-warning alert alert-danger text-danger offset-top-14"><i class="mdi mdi-error"></i> Preencha os campos obrigatorios.</div>').insertAfter('#product .product-prices-content');

        if ($('#product .options-list').length) {
            $('html, body').animate({
                scrollTop: $('#product .options-list').offset().top - 60
            }, 700);
        }
    }

    if (json.error.empty_option) {
        $('#button-cart').before('<div class="alert alert-danger text-danger d-block icon-left" role="alert"><span class="mdi mdi-error"></span> ' + json.error.empty_option + '</div>');
    }
}

function hasCartError(json, $root, is_main_product) {
    if (!json) {
        showBuyTogetherError($root, 'Nao foi possivel adicionar os produtos ao carrinho.');
        return true;
    }

    if (json.error_stock) {
        showCartModal('<p>' + json.error_stock + '</p>');
        return true;
    }

    if (json.error) {
        if (is_main_product) {
            renderMainProductErrors(json);
        }

        showBuyTogetherError($root, 'Verifique as opcoes selecionadas.');
        return true;
    }

    return false;
}

function showCartModal(content) {
    const html = '<div id="modal-cart" class="modal top_modal">' +
        '<div class="modal-dialog">' +
        '<div class="modal-content">' +
        '<div class="modal-body-center" id="modal_body_style">' + content + '</div>' +
        '</div>' +
        '</div>' +
        '</div>';

    $('#modal-cart').remove();
    $('.top_modal').remove();
    $('body').append(html);
    $('.modal-backdrop').remove();
    $('#modal-cart').modal('show');
}

function updateCartInfo(json) {
    if (json.total) {
        $('#cart-total').html(json.total);
        $('.header_sticky #cart-total').html(json.total);
    }

    if (json.total_quantity !== undefined) {
        $('#cart-quantity, .js_cartQuantity').html(json.total_quantity);
        $('.header_sticky #cart-quantity').html(json.total_quantity);
        $('.menu_mobile_fixed_count_products').html(json.total_quantity);
    }

    if (json.total_only_price) {
        $('#cart_total_price').html(json.total_only_price);
        $('#cart_total_price').data('total', json.total_without_format);
    }

    $('#cart .rd-navbar-list-products').load('index.php?route=common/cart/info #cart .rd-navbar-list-products > li');
    $('#cart > ul').load('index.php?route=common/cart/info ul li');
}

function showCartSuccess(json) {
    if (json.success_modal) {
        showCartModal(json.success_modal);
        updateCartInfo(json);
        return;
    }

    if (json.success_redirect && !json.fail_redirect) {
        window.location.href = json.success_redirect;
        return;
    }

    if (json.success_redirect_link) {
        window.location.href = json.success_redirect_link;
        return;
    }

    if (json.success) {
        showCartModal('<p>' + json.success + '</p>');
        updateCartInfo(json);
    }
}

function setBuyTogetherButtonLoading($button, loading) {
    if (!$button || !$button.length) {
        return;
    }

    if (typeof $button.button === 'function' && $button.data('loading-text')) {
        $button.button(loading ? 'loading' : 'reset');
        return;
    }

    if (loading) {
        $button.data('original-text', $button.html());
        $button.prop('disabled', true).addClass('loading').text($button.data('loading-text') || 'Carregando...');
    } else {
        $button.prop('disabled', false).removeClass('loading');

        if ($button.data('original-text')) {
            $button.html($button.data('original-text'));
        }
    }
}

export async function addBuyTogetherToCart(rootElement, buttonElement) {
    const $root = $(rootElement);
    const $button = $(buttonElement);
    const $items = getSelectedBuyTogetherItems($root);
    let last_response = null;

    clearBuyTogetherErrors($root);

    if (!validateBuyTogetherOptions($root, $items)) {
        return;
    }

    setBuyTogetherButtonLoading($button, true);

    try {
        last_response = await addMainProductToCart($root);

        if (hasCartError(last_response, $root, true)) {
            return;
        }

        for (const item of $items.toArray()) {
            last_response = await addBuyTogetherItemToCart($(item));

            if (hasCartError(last_response, $root, false)) {
                return;
            }
        }

        showCartSuccess(last_response);
    } catch (error) {
        console.error('Erro ao adicionar compre junto:', error.responseText || error);
        showBuyTogetherError($root, 'Nao foi possivel adicionar os produtos ao carrinho.');
    } finally {
        setBuyTogetherButtonLoading($button, false);
    }
}

export function initBuyTogether(config = {}) {
    const {
        buyTogetherCount = 0,
        showTotal = false,
        isPositionSide = false
    } = config;

    if (buyTogetherCount >= 2) {
        initBuyTogetherNavigation(buyTogetherCount);
    }

    initBuyTogetherEvents(isPositionSide);

    if (showTotal && !isPositionSide) {
        if ($('.buy-together-btn-content .price').length || $('.buy-together-btn-content .parcel').length) {
            calculateBtTotal();
        }
    }
}

export default {
    init: initBuyTogether,
    parcel,
    productsBuyTogether,
    btProductOption,
    calculateBtTotal,
    initBuyTogetherNavigation,
    initBuyTogetherEvents,
    addBuyTogetherToCart
};
